import { Theme } from '../@types/AppProps';

const WAYKE_VALUATION_THEME = 'wayke-valuation-theme';

export const createTheme = (theme?: Theme) => {
  if (!theme) return;
  const exist = document.getElementById(WAYKE_VALUATION_THEME);
  const style = exist || document.createElement('style');
  style.id = WAYKE_VALUATION_THEME;

  style.innerHTML = `
    .waykevaluation-root {
      --theme-init-bg: ${theme.floatingBackground || 'initial'};
      --theme-init-fg: ${theme.floatingForeground || 'initial'};
      --theme-primary-bg: ${theme.primaryBackground || 'initial'};
      --theme-primary-fg: ${theme.primaryForeground || 'initial'};
      --theme-secondary-bg: ${theme.secondaryBackground || 'initial'};
      --theme-secondary-fg: ${theme.secondaryForeground || 'initial'};
      --theme-link-color: ${theme.linkColor || 'initial'};
      --theme-button-border-radius: ${theme.buttonBorderRadius || 'initial'};
    }
  `;

  if (!exist) {
    document.head.appendChild(style);
  }
};
